module.exports = __webpack_public_path__ + "static/media/machupicchu.02704517.webp";